import { IJob2Action, IJob2s } from "./job2Interface";


export function job2update(jobs: IJob2s): IJob2Action {
    return {
        type: "JOB2_UPDATE",
        payload: jobs,
    }
}
